<template>
<div class="obj-list wrapper ofh" v-if="!loading" v-loading.fullscreen.lock="loading" :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="page__card">
      <div class="page__card-title">
        <div>
            <h1>{{ $store.state.me.organization? `"${$store.state.me.organization.name_cyr}" - ${$t('оbjectsi')}` :$t('all_object_list')  }} </h1>
        </div>
        <div class="flex-1"></div>
        <div class="page__card-item">
            <div class="page__card-router"  @click="checkCadasterModal= true">
                <p class="router__text">{{ $t('check_cadaster_number') }}</p>
                <HCheckCircle class="router__icon"/>
            </div>
            <button v-if="['admin'].includes(me.role.name)" :disabled="changed_cadaster_id === ''" class="page__card-router page__card-router--active"  @click="() => { changeOrganizationModal = true; changeObjectData = objList[changed_cadaster_id]}">
                <p class="router__text">{{ $t('change_the_organization') }}</p>
                <h-reload-circle class="router__icon"/>
            </button>
        </div>
    </div>
    <div class="wp-body">
        <header class="wp-header w-full ">
            <div class="flex-1 flex flex-wrap gap-2 w-full"> 
                <div v-if="['admin', 'ministry', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)" class="w-full sm:w-52">
                    <el-select class="w-full"  v-model="region"  @change="regionChanged(); __GET();" :placeholder="$t('territory')" clearable>
                        <el-option v-for="item in regions" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.shared_id">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="['admin', 'ministry', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)" class="w-full sm:w-52">
                    <el-select class="w-full"  v-model="district" @change="__GET()" :disabled="!region" :placeholder="$t('district')"   clearable>
                        <el-option v-for="item in districts" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex-1 sm:flex-none sm:w-64">
                    <el-input class="search w-full" style="margin-left: 0 !important; flex: 1" :placeholder="$t('search')" prefix-icon="el-icon-search" v-model="search" @keyup.enter.native="__GET()" clearable>
                    </el-input>
                </div>
                <div>
                    <button type="button" :disabled="!region && !district && !search" class="interface-btn bg-rose-50 text-rose-600 hover:bg-rose-100" @click="clearFilter">
                        <IconBroom class="icon"/>
                    </button>
                </div>
            </div>
            <button v-if="!['admin', 'org_admin','ministry_admin','main_org_admin', 'supervisor'].includes(me.role.name)"  id="object-create" class=" add__button w-full sm:w-max" @click="$router.push('/objects/object-create')"> {{$t('add')}} <h-add-circle class="icon" /></button>
        </header>
        <el-table :data="objList" class="sm:my-5" style="width: 99%;" row-key="id" :select-all="false">
            <el-table-column
                v-if="['admin'].includes(me.role.name)"
                width="40" align="center">
                <template slot-scope="scope">
                    <checkbox :value="changed_cadaster_id === scope.$index" @change="(bool)=>{bool ? changed_cadaster_id = scope.$index : changed_cadaster_id = ''}"/>
                </template>
            </el-table-column>
            <el-table-column label="№" width="80px" align="center" >
                <template slot-scope="scope">
                    {{ (current_page - 1) * item_count + (scope.$index + 1) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('cadaster_number')" width="190"  sortable>
                <template slot-scope="scope">
                    <div class="rounded-lg py-1 px-3 bg-indigo-50 font-bold text-indigo-800 leading-snug w-max">
                        <router-link  :to="`/objects/object-info/${scope.row.id}`" class="no-underline">{{ scope.row.cadastral_number }}  </router-link>
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="['admin', 'org_admin', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)" width="350px" prop="organization.name_cyr" :label="$t('organisation_name')" >
            </el-table-column>
            <el-table-column width="100px" :label="$t('year_construction_short')" prop="year_construction" sortable>
            </el-table-column>
            <el-table-column width="150px" :label="$t('add_building_count')" prop="building_count"  sortable>
            </el-table-column>
            <el-table-column width="150px" :label="$t('building_count')" prop="number_buildings"  sortable>
            </el-table-column>
            <el-table-column min-width="190px" :label="$t('created_by')" >
                <template slot-scope="scope">
                    <div class="table-link-button py-1 px-2.5 flex items-center gap-1 bg-slate-100 rounded-md" @click="UserModal(scope.row.created_by)">
                        <div><HUser/></div>
                        <p class="truncate">{{scope.row.created_by!=null && scope.row.created_by.profile!=null ? scope.row.created_by.profile.name+" "+scope.row.created_by.profile.surname : '-' }}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column min-width="190px" :label="$t('updated_by')" >
                <template slot-scope="scope">
                    <div v-if="scope.row.updated_by!=null && scope.row.updated_by.profile!=null" class="table-link-button py-1 px-2.5 flex items-center gap-1 bg-slate-100 rounded-md " @click="UserModal(scope.row.updated_by)">
                        <div><HUser/></div>
                        <p class="truncate">{{scope.row.updated_by!=null && scope.row.updated_by.profile!=null ? scope.row.updated_by.profile.name +" "+ scope.row.updated_by.profile.surname : '-' }}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column  width="110" :label="$t('building_list')" >
                <template slot-scope="scope">
                    <div class="d-flex items-center">
                        <button
                            @click="$router.push({name: 'building-list-one',params: { id: scope.row.id, org:scope.row.organization.name_cyr },}) "
                            class="w-10 h-10 rounded-xl flex justify-center items-center see_button">
                            <HFile01 />
                        </button>
                        <!-- <el-button size="small" @click="$router.push({name: 'obj-info',params: { id: scope.row.id, org:scope.row.organization.name_cyr },}) " class="el-icon-view" type="primary" plain></el-button> -->
                        <el-button v-if="me.role.name == 'operator' && false" @click="deleteObject(scope.row.id )" size="small" class="el-icon-delete el-button-download danger" ></el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="margin-left: auto; margin-top: auto" class="ml-auto" :page-sizes="[10, 20, 50, 100]" :page-size="5" @current-change="paginate" @size-change="paginateSize" :current-page.sync="current_page1" :hide-on-single-page="false" background layout="sizes, prev, pager, next" :page-count="page_count">
        </el-pagination>
    </div>
    <div class="modal fs-14" v-if="usermodal">
        <div class="modal-cover"></div>
        <div class="modal-item" style="max-width:664px; padding: 0 28px 28px;">
            <div class="flex justify-between items-center py-7">
                <p class="modal-title text-slate-950" style="margin: 0; font-size: 24px; line-height: 33px; font-weight: 700; ">{{$t('user_date')}}:</p>
                <button class="bg-slate-100 rounded-xl p-2 text-indigo-900" @click="usermodal=false">
                    <h-remove-circle/>
                </button>
            </div>
            <div class="flex flex-wrap -my-2.5 -mx-1">
                <div class="w-full py-2.5 px-1">
                    <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                        <div>
                            <h-user class="w-8 h-8 text-cyan-600"/>
                        </div>
                        <div class="flex gap-5">
                            <div>
                                <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('last_name')}}</p>
                                <p class="text-black text-base leading-snug font-bold">{{ userData.profile.surname }}</p>
                            </div>
                            <div>
                                <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('first_name')}}</p>
                                <p class="text-black text-base leading-snug font-bold">{{ userData.profile.name }}</p>
                            </div>
                            <div>
                                <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('mid_name')}}</p>
                                <p class="text-black text-base leading-snug font-bold">{{ userData.profile.middlename }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full py-2.5 px-1">
                    <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                        <div>
                            <h-home class="w-8 h-8 text-cyan-600"/>
                        </div>
                        <div class="flex gap-5">
                            <div>
                                <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('organisation_name')}}</p>
                                <p class="text-black text-base leading-snug font-bold">{{ userData.organization && userData.organization.name_cyr ? userData.organization.name_cyr : '-' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-1/2  py-2.5 px-1">
                    <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                        <div>
                            <h-call class="w-8 h-8 text-cyan-600"/>
                        </div>
                        <div class="flex gap-5">
                            <div>
                                <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('phone_munber')}}</p>
                                <p class="text-black text-base leading-snug font-bold">{{ userData.profile.phone_number }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-1/2  py-2.5 px-1">
                    <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                        <div>
                            <h-mail class="w-8 h-8 text-cyan-600"/>
                        </div>
                        <div class="flex gap-5">
                            <div>
                                <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('user_email')}}</p>
                                <p class="text-black text-base leading-snug font-bold">{{ userData.profile.email ? userData.profile.email : '-' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fs-14" v-if="checkCadasterModal">
        <div class="modal-cover"></div>
        <div class="modal-item py-3 sm:py-7 pb-3 sm:pb-7" style="max-width: 920px;">
            <div class="flex justify-between items-center sm:pt-7 sm:pb-5">
                <p class="modal-title text-slate-950 text-xl sm:text-2xl m-0 font-bold">{{$t('object_check_cadaster_number')}}</p>
            </div>
            <div>
                <p class="font-semibold leading-snug text-slate-800 mb-1.5">{{ $t('cadaster_number') }}</p>
                <div class="flex gap-2">
                    <div class="flex-1 relative flex items-center   overflow-hidden">
                        <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400">
                            <IconNumber/>
                        </div>
                        <input v-model="cadastral_number" type="text" :placeholder="$t('cadaster_number')" class="p-3 pl-10 outline-none text-sm font-semibold text-slate-500 w-full border border-slate-200  rounded-xl"
                            @keyup.enter="checkCadasterNumber">
                    </div>
                    <button :disabled="loading_check_cadaster_number" class="bg-indigo-800 hover:bg-indigo-700 text-white rounded-xl px-2 sm:px-4 py-2 flex items-center gap-2" @click="checkCadasterNumber()">
                        <span class="hidden sm:inline-block">{{ $t('search_btn') }}</span> <HSearch v-if="!loading_check_cadaster_number"/> <h-loading v-if="loading_check_cadaster_number" class="spin"/>
                    </button>
                </div>
                <hr v-if="cadastral_info" class="my-5 border-slate-200">
                <div v-if="cadastral_info.message">
                    <p class="text-red-600 leading-snug font-semibold py-1 px-2.5 rounded-lg bg-red-100 w-max">{{ cadastral_info.message }}</p>
                </div>
                <div v-else-if="cadastral_info" :class="{'bg-cool-50 rounded-2xl p-4': !cadastral_info.cadastral_number_old}">
                    <div class="mb-5 flex items-center justify-between">
                        <div class="flex items-center">
                            <icon-object-1 class="text-cyan-600"/>
                            <h1 class="ml-2 text-xl leading-snug font-bold text-slate-950">{{ $t('all_datas') }}</h1>
                        </div>
                        <div>
                            <p v-if="cadastral_info.cadastral_number_old" class="text-emerald-600 leading-snug font-semibold py-1 px-2.5 rounded-lg bg-emerald-100">{{ $t('cadastral_number_updated')}}</p>
                            <p v-else class="text-indigo-600 leading-snug font-semibold py-1 px-2.5 rounded-lg bg-indigo-100">{{ $t('cadastral_number_has_not_updated') }}</p>
                        </div>
                    </div>
                    <div class="flex flex-wrap -my-1 -mx-1">
                        <div v-if="cadastral_info.cadastral_number_old" class="w-1/2 py-1 px-1">
                            <div class="flex gap-3 items-center bg-indigo-50 px-3 py-2 rounded-xl">
                                <div>
                                    <IconNumberSymbol class="w-8 h-8 text-indigo-600"/>
                                </div>
                                <div class="flex-1 flex gap-5">
                                    <div>
                                        <p class="text-indigo-500 text-sm leading-snug font-semibold">{{$t('old_number')}}</p>
                                        <p class="text-indigo-600 text-base leading-snug font-bold">{{ cadastral_info.cadastral_number_old }}</p>
                                    </div>
                                </div>
                                <button class="text-indigo-500" @click="copyCadastral(cadastral_info.cadastral_number_old);">
                                    <HCopy/>
                                </button>
                            </div>
                        </div>
                        <div v-if="cadastral_info.cadastral_number_old" class="w-1/2 py-1 px-1">
                            <div class="flex gap-3 items-center bg-cyan-50 px-3 py-2 rounded-xl">
                                <div>
                                    <IconNumberSymbol class="w-8 h-8 text-cyan-600"/>
                                </div>
                                <div class="flex-1 flex gap-5">
                                    <div>
                                        <p class="text-cyan-600 text-sm leading-snug font-semibold">{{$t('new_number')}}</p>
                                        <p class="text-cyan-600 text-base leading-snug font-bold">{{ cadastral_info.cadastral_number }}</p>
                                    </div>
                                </div>
                                <button class="text-cyan-600" @click="copyCadastral(cadastral_info.cadastral_number);">
                                    <HCopy/>
                                </button>
                            </div>
                        </div>
                        <div v-for="(subject, index) in cadastral_info.subjects" :key="index" class="w-full py-1 px-1">
                            <div class="flex gap-3 items-center px-3 py-2 rounded-xl"
                                :class="cadastral_info.cadastral_number_old ? 'bg-slate-50' : 'bg-white'">
                                <div>
                                    <h-home class="w-8 h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('organisation_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ subject.name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full py-1 px-1">
                            <div class="flex gap-3 items-center px-3 py-2 rounded-xl"
                                :class="cadastral_info.cadastral_number_old ? 'bg-slate-50' : 'bg-white'">
                                <div>
                                    <HMap03 class="w-8 h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('region')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ cadastral_info.region }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('district')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ cadastral_info.district }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('neighborhood')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ cadastral_info.neighborhood }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('address')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ cadastral_info.short_address }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full py-1 px-1">
                            <div class="flex gap-3 items-center px-3 py-2 rounded-xl"
                                :class="cadastral_info.cadastral_number_old ? 'bg-slate-50' : 'bg-white'">
                                <div>
                                    <IconBuilding3 class="w-8 h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('obj_number_buildings')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ cadastral_info.building_count }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button @click="() => { checkCadasterModal = false; cadastral_info = ''; cadastral_number = ''}" class="button bg-slate-50 hover:bg-slate-100 mt-5 float-right cursor-pointer">
                    {{ !cadastral_info || cadastral_info.message ? $t('cancel') : $t('close') }}
                </button>
            </div>
        </div>
    </div>
    <div class="modal fs-14" v-if="changeOrganizationModal">
        <div class="modal-cover"></div>
        <div class="modal-item py-3 sm:py-7 pb-3 sm:pb-7" style="max-width: 920px;">
            <div class="flex flex-wrap items-center pt-4 pb-2 sm:pt-7 sm:pb-5 gap-2.5">
                <p class="text-indigo-800 leading-snug font-bold py-2.5 px-4 rounded-xl bg-indigo-50">{{ changeObjectData.cadastral_number }}</p>
                <p class="modal-title text-slate-950 text-xl sm:text-2xl m-0 font-bold" style="margin: 0;">{{$t('change_object_organization')}}</p>
            </div>
            <div>
                <div class="mb-3">
                    <p class="mb-1.5 text-slate-800 font-semibold text-base leading-snug">{{ $t('current_organization') }}</p>
                    <div class="flex items-center gap-2.5 bg-slate-100 border border-slate-200 px-3 h-10 rounded-xl w-full">
                        <div>
                            <HOutlineHome style="width: 18px; height: 18px; color: #94A3B8;"/>
                        </div>
                        <div>
                            <p class="text-slate-500 text-sm leading-snug font-semibold">{{ changeObjectData.organization && changeObjectData.organization[`name_${$i18n.locale}`] ? changeObjectData.organization[`name_${$i18n.locale}`] : changeObjectData.organization.name_cyr }}</p>
                        </div>
                    </div>
                </div>
                <div >
                    <p class="mb-1.5 text-slate-800 font-semibold text-base leading-snug">{{ $t('transfer_organization') }}</p>
                    <el-select
                        v-model="organization"
                        filterable
                        remote
                        class="w-full select_prefix"
                        :placeholder="$t('organizations')"
                        :remote-method="getOrganizations"
                        @visible-change="onVisibleChange"
                        ref="orgSelect"
                        :loading="loadingOrganizations"
                        >
                            <template slot="prefix">
                                <div class="h-full flex items-center">
                                    <HOutlineHome style="width: 18px; height: 18px; color: #64748B;"/>
                                </div>
                            </template>
                            <el-option
                                v-for="item in reportSampleOrganizations"
                                :key="item.id"
                                :label="item[`name_${$i18n.locale}`]"
                                :value="''+item.id"
                                >
                            </el-option>
                    </el-select>
                </div>
                <div class="flex justify-end mt-5">
                    <button @click="() => { changeOrganizationModal = false; organization = undefined;}" class="rounded-xl px-4 py-2 font-semibold text-base leading-snug bg-slate-50 hover:bg-slate-100 cursor-pointer">
                        {{ $t('cancel') }}
                    </button>
                    <button @click="changeOrganization()" 
                        :disabled="!organization || loadingChangeOrganization"
                        class="rounded-xl px-4 py-2 ml-2   flex items-center gap-2 font-semibold text-base leading-snug"
                        :class="!organization || loadingChangeOrganization ? 'cursor-not-allowed bg-slate-200 text-slate-600' : 'bg-emerald-500 text-white hover:bg-emerald-600'"
                        >
                        {{ $t('save')  }} 
                        <h-loading v-if="loadingChangeOrganization" class="spin"/>
                        <h-check-circle v-else/>
                    </button>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>

<ScletonPage header="true" v-else class="m-5 p-5 rounded-3xl bg-white" />
</template>

<script>
import IconBroom from '@/components/Icons/iconBroom.vue';
import HAddCircle from '../../components/Icons/hAddCircle.vue';
import HCall from '../../components/Icons/hCall.vue';
import HCheckCircle from '../../components/Icons/hCheckCircle.vue';
import HCopy from '../../components/Icons/hCopy.vue';
import HFile01 from '../../components/Icons/hFile01.vue';
import HHome from '../../components/Icons/hHome.vue';
import HLoading from '../../components/Icons/hLoading.vue';
import HMail from '../../components/Icons/hMail.vue';
import HMap03 from '../../components/Icons/hMap03.vue';
import HOutlineHome from '../../components/Icons/hOutlineHome.vue';
import HReloadCircle from '../../components/Icons/hReloadCircle.vue';
import HRemoveCircle from '../../components/Icons/hRemoveCircle.vue';
import HSearch from '../../components/Icons/hSearch.vue';
import HUser from '../../components/Icons/hUser.vue';
import IconBuilding3 from '../../components/Icons/iconBuilding3.vue';
import IconNumber from '../../components/Icons/iconNumber.vue';
import IconNumberSymbol from '../../components/Icons/iconNumberSymbol.vue';
import IconObject1 from '../../components/Icons/iconObject1.vue';
import ScletonPage from '../../components/Scletons/Page.vue'
import Checkbox from '../../components/ui/Checkbox.vue';
export default {
    components:{
        ScletonPage,
        HUser,
        HFile01,
        HRemoveCircle,
        HHome,
        HCall,
        HMail,
        HCheckCircle,
        HReloadCircle,
        HAddCircle,
        IconNumber,
        HSearch,
        HLoading,
        HMap03,
        IconBuilding3,
        IconNumberSymbol,
        HCopy,
        IconObject1,
        Checkbox,
        HOutlineHome,
        IconBroom
    },
    data() {
        return {
            changeOrganizationModal: false,
            loadingChangeOrganization: false,
            changeObjectData: {},
            changed_cadaster_id: '',
            organization: undefined,
            reportSampleOrganizations: [],
            loadingOrganizations: false,
            searchOrg: "",
            page_count: 1,
            current_page: 1,
            current_page1: 1,
            isAdmin: false,
            loading: false,
            item_count: 10,
            input2: null,
            objList: [],
            districts: [],
            region: "",
            district: "",
            search: "",
            cadastral_number: "",
            cadastral_info: '',
            loading_check_cadaster_number: false,
            usermodal: false,
            checkCadasterModal: false,
            userData: {
                organization: {},
                profile: {}
            }
        };
    },
    computed: {
        me() {
            return this.$store.state.me;
        },
        regions() {
            return this.$store.state.dictionary.region;
        },
    },
    mounted() {
        this.getOrganizations()
        this.loading = true
        this.current_page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
        this.search = this.$route.query.search ? this.$route.query.search : ''
        this.region = this.$route.query.region && this.$route.query.region != '' ? parseInt(this.$route.query.region) : ''
        this.district = this.$route.query.district ? parseInt(this.$route.query.district) : ''
        this.item_count = this.$route.query.item_count ? this.$route.query.item_count : 10
        if (this.region != '') {
            this.getDistrict()

        }
        this.__GET();
    },
    methods: {
        paginate(val) {
            this.current_page = val;
            this.__GET();
        },
        paginateSize(val) {
            this.item_count = val
            this.__GET();
        },
        clearFilter() {
            this.region = '';
            this.district = ''
            this.search = ''
            this.__GET()
        },
        __GET() {
            this.loading = true;
            let offset = this.item_count * (this.current_page - 1);

            if (this.$route.query.id) {
                this.isAdmin = true;
                if (this.search != '' || this.region != '' || this.district != '' || this.item_count != 10) {
                    this.$router.push(`/objects?id=${this.$route.query.id}&page=${this.current_page}&region=${this.region}&district=${this.district}&item_count=${this.item_count}&search=${this.search}`)
                        .catch(e => {
                            if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                                console.log(e)
                            }
                        });
                } else {
                    this.$router.push(`/objects?id=${this.$route.query.id}&page=${this.current_page}`)
                        .catch(e => {
                            if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                                console.log(e)
                            }
                        });
                }
                axios.get(
                        `/building/generalinformation/?organization=${this.$route.query.id}&region__shared_id=${this.region}&district=${this.district}&search=${this.search}&limit=${this.item_count}&offset=${offset}`
                    )
                    .then((response) => {
                        this.objList = response.data.results;
                        this.page_count = Math.ceil(response.data.count / this.item_count);
                        this.current_page1 = this.$route.query.page ? parseInt(this.$route.query.page) : 1
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                if (this.search != '' || this.region != '' || this.district != '' || this.item_count != 10) {
                    this.$router.push(`/objects?page=${this.current_page}&region=${this.region}&district=${this.district}&item_count=${this.item_count}&search=${this.search}`)
                        .catch(e => {
                            if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                                console.log(e)
                            }
                        });
                } else {
                    this.$router.push(`/objects?page=${this.current_page}`)
                        .catch(e => {
                            if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                                console.log(e)
                            }
                        });
                }

                axios
                    .get(
                        `/building/generalinformation/?region__shared_id=${this.region}&district=${this.district}&search=${this.search}&limit=${this.item_count}&offset=${offset}`
                    )
                    .then((response) => {
                        this.objList = response.data.results;
                        this.page_count = Math.ceil(response.data.count / this.item_count);
                        this.current_page1 = this.$route.query.page ? parseInt(this.$route.query.page) : 1

                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        regionChanged() {
            this.districts = [];
            this.district = "";
            this.getDistrict();
        },

        getDistrict() {
            this.loading = true;
            axios
                .get(`/dictionary/district/?region__shared_id=${this.region}`)
                .then((response) => {

                    this.districts = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        UserModal(a) {
            if (a != null && a.profile != null) {
                this.userData = a
                this.usermodal = true
            }
        },
        deleteObject(id) {
            return this.$confirm(`Сиз ушбу обеъктни ўчирсангиз, обеъктга тегиши бўлган барча бинолар тизимдан ўчирилади. Обекътни ростдан ўчирмоқчимисиз?`, {
                    confirmButtonText: 'Ҳа',
                    cancelButtonText: 'Йўқ',
                })
                .then(() => {
                    axios.delete(`/building/generalinformation/${id}/`)
                        .then((response) => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Қониқарли. Обеъкт ва унинг бинолари мувоффақиятли ўчирилди.',
                                timer: 3000
                            });
                            this.__GET();
                        })
                        .catch(error => {
                            this.$swal.fire({
                                icon: 'error',
                                title: 'Ўчиришда хатолик юзберди.',
                                timer: 3000
                            });
                        })
                })

        },
        checkCadasterNumber() {
            if (!this.cadastral_number || this.loading_check_cadaster_number) return
            this.loading_check_cadaster_number = true
            axios.get(`building/cadastral-info/?cadastral_number=${this.cadastral_number}/`)
                .then((response) => {
                    this.cadastral_info = response.data
                    
                })
                .catch(error => {
                    console.log(error);
                    
                }).finally(() => {
                    this.loading_check_cadaster_number = false
                })
        },
        copyCadastral(number) {
            if (!number) return;

            navigator.clipboard.writeText(number)
                .then(() => {
                    this.$message.success(this.$t('copied') +': ' + number); 
                })
        },
        getOrganizations(search, offset) {
            this.searchOrg = search;
            if(offset > 0 && offset > this.count) return;
            this.loadingOrganizations = true;
            if (!offset) {
                this.offset = 0;
                this.reportSampleOrganizations = []
            }
            axios.get(`/organization/`, { params: { search, offset, limit: 30 } })
                .then(response => {
                    offset ? this.reportSampleOrganizations.push(...response.data.results) : this.reportSampleOrganizations = response.data.results;
                    this.count = response.data.count
                })
                .catch(() => {
                    this.reportSampleOrganizations = [];
                })
                .finally(() => {
                    this.loadingOrganizations = false;
                });
        },
        onVisibleChange(val) {
            const dropdown = this.$refs.orgSelect.$refs.scrollbar.wrap;
            if (val) {
                dropdown.addEventListener("scroll", this.handleScroll);
            }
            else {
                dropdown.removeEventListener("scroll", this.handleScroll);
                this.offset = 0
                this.count = 0
                this.searchOrg = ''
                this.getOrganizations()
            }
        },
        handleScroll(e) {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            if (scrollTop + clientHeight >= scrollHeight - 10 && !this.loadingOrganizations) {
                this.offset += 30
                this.getOrganizations(this.searchOrg, this.offset);
            }
        },
        changeOrganization() {
            this.loadingChangeOrganization = true
            axios.patch(`/building/generalinformation/${this.changeObjectData.id}/update_organization/`, { organization: this.organization })
                .then((response) => {
                    this.$swal.fire({
                        icon: 'success',
                        title: this.$i18n.locale === 'cyr' ? 'Қониқарли. Ташкилот муваффақиятли ўзгартирилди.' : 'Удовлетворительно. Организация успешно изменена.',
                        timer: 3000
                    });
                    this.changeOrganizationModal = false
                    this.organization = undefined
                    this.changed_cadaster_id = ''
                    this.__GET();
                })
                .catch(error => {
                    this.$swal.fire({
                        icon: 'error',
                        title: this.$i18n.locale === 'cyr' ? 'Ўзгартиришда хатолик юзберди.' : 'Ошибка при изменении.',
                        timer: 3000
                    });
                }).finally(() => {
                    this.loadingChangeOrganization = false
                })
        }
    },
};
</script>

<style lang="scss" scoped>
.top-header {
    width: 100%;
    padding: 15px 20px; 
    border-radius: 16px;
    background: #3730A3;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.top-header h1 {
     font-weight: 600;
    font-size: 18px;
    color: #fff !important;
}

.title-second-header {
   font-size: 18px;
   font-weight: 600;
   color: #3730A3 !important;
}

.page__card-item {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    @media screen and (max-width: 1024px) {
        gap: 12px;
    }
}

.page__card-router {
    padding: 8px 16px;
    border-radius: 12px;
    background: #EEF2FF;
    transition: all 0.3s ease;
    color: #1E293B;
    display: flex;
    align-items: center;
    gap: 8px;
    @media screen and (max-width: 575px) {
        justify-content: center;
        width: 100%;
    }
    cursor: pointer;

    .router__text {
        font-weight: 600;
        line-height: 22px;
    }

    .router__icon {
        color: #0891B2;
        width: 24px;
        height: 24px;
    }

    &:hover {
        background: #E0E7FF;
    }

    &--active {
        background: #3730A3;
        color: white;

        &:hover {
            background: #4338CA;
        }

        .router__icon {
            color: white;
        }

        &:disabled{
            background: #E2E8F0;
            color: #475569;
            cursor: not-allowed;
            .router__icon {
                color: #94A3B8;
            }
        }
    }
}


</style>
